<template>
  <div class="card mb-2">
    <b-card-header class="esep-blue-bg text-light">
      <h6 v-if="action == 'approve'" class="float-left font-weight-bold"> {{ $t('participations.approveParticipation') + participation.activity.module.title + " (" + participation.activity.id +")"}} </h6>
      <h6 v-else class="float-left font-weight-bold"> {{ $t('participations.rejectParticipation') + participation.activity.module.title + " (" + participation.activity.id +")"}} </h6>
    </b-card-header>
    <b-card-body>
      <template v-if="action === 'approve'">
        <b-form-group
            id="input-application-type-label"
            :label="$t('participation.depositType')"
            label-for="input-application-type"
            label-align="left"
            class="ml-3"
        >
          <v-select
              :options="depositTypes"
              v-model="participation.paymentType"
              :filterable="false"
              label="text"
              :reduce="cat => cat.value"
              :selectable="cat => canSelect(cat.value)"
              :full-width="true"
              style="width: 400px;"
          />
        </b-form-group>

        <b-form-group
            id="input-application-type-label"
            :label="$t('participation.depositNo')"
            label-for="input-application-depositNo"
            label-align="left"
            v-if="['FINANCE_DEP','BANK'].includes(participation.paymentType)"
            class="ml-3"
        >
          <b-form-input  id="input-with-depositNo" v-model="participation.depositNo"/>
        </b-form-group>

        <b-form-group
            id="input-application-type-label"
            :label="$t('participation.depositComments')"
            label-for="input-application-depositComments"
            label-align="left"
            v-if="['FINANCE_DEP','BANK'].includes(participation.paymentType)"
            class="ml-3"
        >
          <b-form-input id="input-with-depositComments" v-model="participation.depositComments"/>
        </b-form-group>
      </template>
      <template v-else>
        <b-form-group
            id="input-group-comment"
            :label="$t('participations.comments')"
            label-for="input-comment"
            label-align="left"
            class="col-md-12"
        >
          <b-form-input
              id="input-comment"
              v-model="comments"
              type="text"
          ></b-form-input>
        </b-form-group>

      </template>

      <div class="float-left mt-2">
        <b-button @click="submitParticipation" variant="success" class="mr-1"
                  v-if="this.action !== 'cancel'"
          >{{
            this.action === 'approve'? $t("common.approve"): $t("common.reject")
        }}</b-button>
        <b-button @click="cancelParticipation" variant="success" class="mr-1"
                  v-if="this.action === 'cancel'"
        >{{
            $t("common.confirm")
          }}</b-button>
        <b-button @click="hideForm" variant="danger" >{{
          $t("common.reset")
        }}</b-button>
      </div>
    </b-card-body>
  </div>
</template>

<script>
  export default {
    props: {
      action: String,
      participation: Object,
    },
    data() {
      return {
        comments: '',
        depositTypes: [
          { value: "RF_CODE", text: this.$t('paymentTypeEnums.RF_CODE'), enabled: true },
          { value: "IN_PERSON", text: this.$t('paymentTypeEnums.IN_PERSON'), enabled: true },
          { value: "ISLAND_DISCOUNT", text: this.$t('paymentTypeEnums.ISLAND_DISCOUNT'), enabled: true },
          { value: "BANK", text: this.$t('paymentTypeEnums.BANK'), enabled: true },
          { value: "FINANCE_DEP", text: this.$t('paymentTypeEnums.FINANCE_DEP'), enabled: true },
          { value: "NONE", text: this.$t('paymentTypeEnums.NONE'), enabled: false }
        ],
      }
    } ,
    methods: {
      submitParticipation() {
        let data = {
          approved: this.action === 'approve',
          participation: this.participation
        }
        this.comments = ''; //not used for now
        this.$emit('approve-reject-participation', data);
      },
      cancelParticipation() {
        this.$emit('cancel-participation');
      },
      hideForm() {
        this.comments = '';
        this.$emit('hide-form');
      },
      canSelect(choice) {
        return this.participation.activity.paymentTypes.includes(choice) || (choice === 'ISLAND_DISCOUNT' && this.participation.activity.paymentTypes.includes('RF_CODE'));
      }
    }
  }
</script>